module.exports = __webpack_public_path__ + "resources/img/m_banner7.e5d86a4d763f7eb72def1172d522cf18.png";